import api from './api';

// Talks to /api/reports/* — MOD_10_REPORT.
//
// Reporting is ONE module with MANY SECTIONS (Revenue Management, Operating
// Expenses, Manufacturing, People, …), one per operational sidebar item.
// ACCESS FOLLOWS THE MODULE: a section names the module it reports on, and
// holding that module opens it. role_report_access still exists as an additive
// override for the cross-functional case. The server filters both the section
// list and the report data, so anything absent here is absent because the
// acting role may not see it — the front end never decides that.
export const reportService = {
  // { sections: [{ section_code, section_name, description, icon, module_code,
  //   module_name, report_count }], total_sections, sees_all }
  getSections: async () => (await api.get('/reports/sections')).data,

  // { section, reports: [{ report_code, report_name, description, runnable }] }
  getSection: async (sectionCode) => (await api.get(`/reports/sections/${sectionCode}`)).data,

  // The report as data — the on-screen view renders from this, so a report
  // still works when the render service is down.
  //
  // `compare` is a source key: "version:V1", "actual:2025", "actual:2025:1-6".
  // Omit it and the report is exactly what it was before comparison existed.
  getReportData: async (reportCode, params = {}) =>
    (await api.get(`/reports/${reportCode}/data`, { params })).data,

  // What this report may be read against.
  // { versions: [...], actuals: [...], supports_versions, supports_actuals,
  //   actuals_note }
  //
  // Entries carry `available` and, when false, a `sub` saying WHY — an actuals
  // year with no import behind it is listed and disabled rather than hidden,
  // so a reader can go and ask for the import instead of concluding the
  // comparison does not exist.
  getCompareSources: async (reportCode) =>
    (await api.get(`/reports/${reportCode}/compare-sources`)).data,
};

export default reportService;
